<h3>Heilbehelfe &amp; Hilfsmittel</h3>


<form class="form-vertical" id="aideform" name="aideform">
  <!-- Überweisung für: -->
  <div class="form-group" ng-show="vm.standalone">
    <!-- Patientensuche -->
    <label for="reffor">Patient</label>
    <div class="form-group  col-xs-12" ng-hide="vm.newaide.patientid">
      <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>
    </div>
    <div class="form-group col-xs-12" ng-show="vm.newaide.patientid">
      <div class="input-group">
        <input type="text" class="form-control"
               id="patientname"
               tabindex="0"
               readonly
               ng-model="vm.newaide.patient.fname">
        <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>
                    </button>
                </span>
      </div>
    </div>
  </div>

  <!-- Überweisung an: -->
  <div class="form-group">
    <label for="refto">
      <span
        uib-tooltip="Es muß entweder ein Arzt aus der Liste ausgewählt werden oder das Feld Freitext ausgefüllt werden">
        An/Zu: Arztauswahl ODER freie Texteingabe
      </span>
      <span uib-tooltip="Pflichtfeld">*</span>
    </label>

    <div class=" row">
      <!-- Arztsuche - -->
      <div class="form-group  col-xs-12" ng-hide="vm.newaide.doctor._id">
        <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>
      </div>
      <div class="form-group col-xs-12" ng-show="vm.newaide.doctor._id">
        <div class="input-group">
          <input type="text" class="form-control"
                 id="pdoctorname"
                 tabindex="0"
                 readonly
                 ng-model="vm.newaide.doctor.fname">
          <span class="input-group-btn">
                    <button class="btn btn-danger"
                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>
                    </button>
                </span>
        </div>
      </div>
    </div>
    <div class=" row">
      <!-- Freitext -->
      <div class="col-xs-12 spacer-bottom">
        <input type="text" ng-model="vm.newaide.to" tabindex="0"
               ng-required="!(vm.newaide.to || vm.newaide.doctor)"
               ng-hide="vm.newaide.doctor"
               tabindex="0"
               style="margin-top: -5px;"
               placeholder="Freitext für Überweisungsziel" class="form-control" id="refto">
      </div>

    </div>
  </div>
  <!-- diagnose/Begründung -->
  <div class="form-group">
    <label for="refdiag">Diagnose/Begründung<span uib-tooltip="Pflichtfeld">*</span></label>
    <input required type="text" ng-model="vm.newaide.diag"
           class="form-control" id="refdiag" tabindex="0">
  </div>


  <div>
    <form class="form-inline">
      <div class="row" ng-show="vm.aideconfig.groups.length > 0">
        <h4>Heilbehelfsgruppen</h4>
        <!-- value groups -->
        <div ng-repeat="group in vm.aideconfig.groups">
          <div class="form-group col-md-4">
            <label>
              <input type="checkbox"
                     ng-model="vm.newaide.ginclude[$index]"
                     tabindex="0"
                     ng-checked="vm.newaide.ginclude[$index]"
                     ng-init="vm.newaide.ginclude[$index] = false"
                     ng-click="vm.toggleGroup()"/> {{group.name}}</label>
          </div>
        </div>
      </div>

      <!-- add additional values -->
      <label for="addlabval" ng-show="vm.aideconfig.groups.length > 0">Zusätzliche Heilbehelfe</label>
      <label for="addlabval" ng-show="vm.aideconfig.groups.length === 0">Heilbehelfe</label>
      <tags-input ng-model="vm.newaide.additionalvalues"
                  ng-init="vm.newaide.additionalvalues = []"
                  tabindex="0"
                  display-property="name" id="addlabval"
                  add-on-comma="false"
                  min-length="1"
                  placeholder="Tippen zum Vervollständigen"
                  replace-spaces-with-dashes="false"
                  on-tag-added="vm.joinValues()"
                  on-tag-removed="vm.joinValues()"
                  template="tag-template">
        <auto-complete source="vm.loadValues($query)"
                       min-length="1"
                       load-on-focus="false"
                       load-on-down-arrow="true"
                       load-on-empty="true"
                       max-results-to-show="32"
                       template="autocomplete-template"></auto-complete>
      </tags-input>

      <!-- selected values -->
      <h4>Ausgewählte Heilbehelfe &amp; Hilfsmittel</h4>

      <div class="alert alert-info">
        <span ng-show="vm.newaide.allvalues.length > 0" ng-repeat="val in vm.newaide.allvalues">{{val}}{{$last ? '' : ', '}} </span>
        <span ng-hide="vm.newaide.allvalues.length > 0">Keine Werte ausgewählt</span>
      </div>


    </form>


    <!-- Erbeten -->
    <div class="form-group">
      <label for="refref">Erbeten<span uib-tooltip="Pflichtfeld">*</span></label>
      <textarea class="form-control" ng-model="vm.newaide.aide" rows="5"
                ng-required="!(vm.newaide.ref ||  vm.newaide.allvalues)"
                id="refref" tabindex="0"></textarea>
    </div>

    <!-- gültig -->
    <div class="form-group">
      <label>Gültig </label>
      <div class="radio">
        <label class="radio-inline">
          <input type="radio" ng-value="true" ng-model="vm.newaide.pdate"
                 ng-click="vm.setRefDate()">
          1 Monat</label>
        <label class="radio-inline">
          <input type="radio" ng-value="false" ng-model="vm.newaide.pdate"
                 ng-click="vm.newaide.refdate = ''">
          Kein Datum</label>
      </div>
    </div>

    <!-- Buttons -->
    <div ng-show="vm.standalone" class="spacer-bottom ">
      <button class="btn btn-success" ng-disabled="aideform.$invalid" type="button" ng-click="vm.print();"
              tabindex="0">
        Drucken
      </button>
    </div>
    <div class="alert alert-success" ng-show="vm.printed === true"><i class="fa fa-check"></i> Verordnung erfolgreich gedruckt</div>
    <div class="alert alert-danger" ng-show="vm.printed === false"><i class="fa fa-warning"></i> Druck der Verordnung fehlgeschlagen</div>


    <div ng-hide="vm.standalone">
      <button class="btn btn-success" ng-disabled="aideform.$invalid" type="button" ng-click="vm.add();"
              tabindex="0">
        Speichern
      </button>

      <button class="btn btn-danger" type="button" ng-click="vm.cancel()" tabindex="0">
        Abbrechen
      </button>
    </div>
  </div>

  <div class="spacer-top"></div>
 <div class="alert alert-success" ng-show="vm.saved"><i class="fa fa-check text-success"></i> Verordnung erfolgreich gespeichert!</div>
 <div class="alert alert-info" ng-show="vm.canceled"><i class="fa fa-info-circle text-primary"></i> Erstellen der Verordnung wurde abgebrochen.</div>
 <div class="alert alert-danger" ng-show="vm.savefailed"><i class="fa fa-warning text-danger"></i> Verordnung konnte nicht gespeichert werden!</div>
</form>


<script type="text/ng-template" id="tag-template">
  <div class="tag-template">
    <div class="right-panel">
      <span>{{$getDisplayText()}}</span>
      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
    </div>
  </div>
</script>


<script type="text/ng-template" id="autocomplete-template">
  <div class="autocomplete-template">
    <div>
      <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>
    </div>
  </div>
</script>

<div style="min-height:3cm">&nbsp;</div>